import styled from '@emotion/styled/macro';

export const ButtonLink = styled.a`
    width: 100%;
`;

export const CountDownTimerWrapper = styled.div`
    width: 100%;
    margin-bottom: ${props => props.theme.spacing.xlarge};
`;

export const ContentWrapper = styled.div`
    width: 100%;
    text-align: center;
    padding: 0 ${props => props.theme.spacing.large} 0
        ${props => props.theme.spacing.large};
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    @media (min-width: 1024px) {
        padding: 0;
    }
`;

export const BetPromoWrapper = styled.div`
    width: 100%;
    margin: ${props => props.theme.spacing.large} 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Promos = styled.p`
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #fff;
`;

export const PlayItv7Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    align-items: center;
    margin: ${props => props.theme.spacing.large} 0;

    @media (min-width: 600px) {
        flex-direction: row;
        align-items: stretch;
    }
`;

export const PlayItv7Heading = styled.h3`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.large};
    color: ${props => props.theme.colours.textDark};
    text-align: center;
    text-transform: uppercase;
    margin: ${props => props.theme.spacing.large} 0 0;
    letter-spacing: 0.5px;
`;

export const UpComingRoundsWrapper = styled.div`
    width: 100%;
    margin: ${props => props.theme.spacing.large} 0;
`;

export const ShareWrapper = styled.div`
    width: 100%;
    margin-top: ${props => props.theme.spacing.large};
    display: flex;
    justify-content: center;
    align-items: center;
`;
